






import { Component, Vue, Prop } from 'vue-property-decorator';
import { Typography } from '@/components/atoms';

@Component({ components: { Typography } })
export default class TitleOnboarding extends Vue {
  @Prop({ default: 'Twism' }) readonly title?: string;
  @Prop({ default: false }) readonly page?: boolean;
  @Prop({ default: '' }) readonly step?: string;
}
